module.exports = __webpack_public_path__ + "media/images/texting-1b727a49aafbdc5b0dd818dda41b3017.svg";